
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetCommunityGroupMembers, GetCommunityGroupMembersResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";

const getData = (response?: SWRResponse<GetCommunityGroupMembersResponse, GetCommunityGroupMembersResponse>) => response?.data?.members
const getError = (response?: SWRResponse<GetCommunityGroupMembersResponse, GetCommunityGroupMembersResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetCommunityGroupMembersResponse, GetCommunityGroupMembersResponse>) => ({});

const useGetCommunityGroupMembers = (query?: Partial<GetCommunityGroupMembers>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetCommunityGroupMembers(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetCommunityGroupMembers;